module.exports = __webpack_public_path__ + "static/img/2.7efdf53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/01/2.png
// module id = HOFH
// module chunks = 1